import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const RevolutIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/revolutLogo.png" style={style} />
}
